import NoAssignment from '../../../assets/images/NoAssignment.png';
import PropTypes from 'prop-types';
import { useMyContentContext } from '../utils/myContentContext';
import { useEffect, useState } from 'react';

const EmptySet = ({
  handleCreateSet,
  showDeletedSets,
  handleShowDeletedChanges
}) => {
  const { activeTab } = useMyContentContext();
  const [name, setName] = useState('');

  useEffect(() => {
    switch (activeTab) {
    case 'questionsets':
      setName('Question');
      break;
    case 'resourcesets':
      setName('Resource');
      break;
    default:
      setName('');
    }
  }, [activeTab]);

  return(
    <>
      <div className="d-flex align-items-center form-check col-auto">
        <input
          type="checkbox"
          id="displayDeletedSets"
          className="form-check-input mx-1 ms-auto"
          checked={showDeletedSets}
          onChange={() => handleShowDeletedChanges()}
        />
        <label className="form-check-label" htmlFor="displayDeletedSets">
          Display Deleted Sets
        </label>
      </div>
      <div className='mb-0 my-4 no-content-card'>
        <div className="text-center mb-5">
          <img src={NoAssignment} className='my-4' />
          <p className='mb-4'>
            {name} set is currently empty, use the <strong>Add buttons</strong> to add {name.toLowerCase()} set.
          </p>
          <div className='col-md-6 d-flex gap-3 justify-content-center w-100'>
            <button onClick={() => handleCreateSet()} className='btn btn-castleRed'>
            Add {name} Set
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

EmptySet.propTypes = {
  handleCreateSet: PropTypes.func,
  showDeletedSets: PropTypes.bool,
  handleShowDeletedChanges: PropTypes.func,
};

export default EmptySet;